import styled from 'styled-components';
import variables from '../../../styles/variables';
import Link from '../../UI/Link/Link';

export const Section = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;
  position: relative;
  margin: 0 auto;

  @media screen and (max-width: 1024px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
    flex-wrap: wrap;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  row-gap: 3rem;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    'gallery variant'
    'specs specs';
  max-width: ${variables.defaultWidth}px;
  position: relative;
  margin: 0 auto;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    row-gap: 2rem;
    grid-template-areas:
      'gallery'
      'variant'
      'specs';
  }
`;

export const Gallery = styled.div`
  width: 100%;
  height: 100%;
  grid-area: gallery;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  margin: 0 auto;

  @media screen and (max-width: 640px) {
    flex-direction: column;
  }
`;

export const ImageGalleryContainer = styled.div`
  width: 100%;
`;

export const CtaContainer = styled.div`
  margin: 1rem auto 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    margin: 0 auto;
    font-size: 16px;
  }
`;

export const Variant = styled.div`
  grid-area: variant;
  width: 100%;
  height: 100%;
  margin: 0 auto;

  @media screen and (max-width: 640px) {
    flex-direction: column;
  }
`;

export const Manufacturer = styled.div`
  display: none;
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  line-height: 34px;
  text-align: left;
  margin-bottom: 4px;
  word-break: break-word;

  @media screen and (max-width: 1024px) {
    display: flex;
    font-size: 20px;
    line-height: 22.34px;
  }
`;

export const Headline = styled.h1`
  display:none;
  width: 100%;
  color: ${variables.colorBlack};
  text-transform: none;
  margin-bottom: 10px;
  font-size: 30px;
  line-height: 34px;
  font-weight: 400;
  word-break: break-word;

  @media screen and (max-width: 1024px) {
    display: flex;
    font-size: 20px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 8px;
  }
`;

export const ProductSku = styled.div`
  display: none;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 100%;
  width: 100%;
  margin-bottom: 32px;

  @media screen and (max-width: 1024px) {
    display: flex;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const ProductSkuItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 12px;
  line-height: 14px;
  padding-right: 0.5rem;

  @media screen and (max-width: 600px) {
    margin-bottom: 5px;
  }

  &:last-child {
    @media screen and (max-width: 600px) {
      margin-bottom: 0;
    }
  }

  strong {
    padding-right: 0.25rem;
  }
`;

export const ProductSkuBrand = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 12px;
  line-height: 14px;
  font-size: 12px;
  line-height: 14px;
  color: ${variables.colorRed};
  text-decoration: underline;
  margin-bottom: 0;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;
